document.addEventListener('DOMContentLoaded', function() {
    const shareBtn = document.querySelector('.native-share');

    if (!shareBtn) return;
    
    // Controlla se l'API Web Share è supportata
    if (navigator.share) {
      // Mostra il pulsante nativo e nascondi il fallback
      shareBtn.style.display = 'inline-block';
      
      // Aggiungi l'evento di condivisione
      shareBtn.addEventListener('click', async () => {
        try {
          await navigator.share({
            title: document.title,
            text: 'Guarda questa pagina:',
            url: window.location.href
          });
          console.log('Condivisione avvenuta con successo');
        } catch (err) {
          console.log('Condivisione annullata', err);
        }
      });
    }
  });